module.exports = __webpack_public_path__ + "static/media/maria_goreti_lopes_cepinho.cadd167d.jpg";